import { ActionType, Action, driverState } from "../actions/types";

const initialDriverState: driverState = {
  driver: {
    name: "",
    phone: "",
  },
};

const driverReducer = (
  state: driverState = initialDriverState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_DRIVER:
      return {
        ...state,
        driver: action.payload,
      };
    default:
      return state;
  }
};

export default driverReducer;
